import { DialogContent } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import React, { Fragment } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Loading from "../loading";
import PopUp from "../popUpInterface";
import { styles } from "./styles";

/*----styles----*/
class Review extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      html: null,
    };
  }
  componentDidMount() {
    this.props.onRef(this);
  }
  open = (html) => {
    if (html) this.setState({ html: html });
    this.PopUp.handleDialogOpen();
  };
  close = () => {
    this.PopUp.handleDialogClose();
  };
  update = () => {
    const { html } = this.state;
    this.props.updateHTML(html);
    this.close();
  };
  handleChange = (e) => {
    let target = e.target;
    this.setState({ html: target.value });
  };
  render() {
    const { html } = this.state;
    const { classes } = this.props;

    return (
      <Fragment>
        <PopUp
          onRef={(dialog) => (this.PopUp = dialog)}
          openDialogs={this.state.openDialogs}
          aria-labelledby="customized-dialog-title"
          flagOpen={false}
          handleDialogClose={this.close}
        >
          <Loading onRef={(id) => (this.loading = id)} />
          <DialogContent className={classes.DialogContent}>
            <div dangerouslySetInnerHTML={{ __html: html }}></div>
          </DialogContent>
        </PopUp>
      </Fragment>
    );
  }
}
const mapState = (state) => ({
  serviceBranchState: state.serviceBranch,
});
const mapDispatch = (dispatch) => ({
  employeeDispatch: dispatch.employees,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Review)));
